import React, { ReactElement } from "react";
import { Tabs } from "@/components/ui";
import { PostDetails } from "@/services/bedrock";
import { socialNetworkNames } from "@/interfaces";
import { Clock, Send, CheckCircle, XCircle, Trash2, ClipboardCheck, WifiOff } from "lucide-react";

const STATUS_STYLE_CONFIG: Record<string, { textColor: string; bgColor?: string; icon: ReactElement }> = {
  PENDING: {
    textColor: "text-blue-700",
    bgColor: "bg-blue-50",
    icon: <Clock className="w-4 h-4 text-blue-700" />,
  },
  IN_TRANSIT: {
    textColor: "text-amber-700",
    bgColor: "bg-amber-50",
    icon: <Send className="w-4 h-4 text-amber-700" />,
  },
  POSTED: {
    textColor: "text-emerald-700",
    bgColor: "bg-emerald-50",
    icon: <CheckCircle className="w-4 h-4 text-emerald-700" />,
  },
  FAILED: {
    textColor: "text-red-700",
    bgColor: "bg-red-50",
    icon: <XCircle className="w-4 h-4 text-red-700" />,
  },
  DELETED: {
    textColor: "text-slate-600",
    bgColor: "bg-slate-100",
    icon: <Trash2 className="w-4 h-4 text-slate-600" />,
  },
  FAILURE_ACKED: {
    textColor: "text-violet-700",
    bgColor: "bg-violet-50",
    icon: <ClipboardCheck className="w-4 h-4 text-violet-700" />,
  },
  SKIPPED_NO_CONNECTION: {
    textColor: "text-slate-600",
    bgColor: "bg-slate-100",
    icon: <WifiOff className="w-4 h-4 text-slate-600" />,
  },
};

interface NetworkTabsProps {
  post: PostDetails;
  activeNetworkTab: string;
  setActiveNetworkTab: (val: string) => void;
}

export function NetworkTabs({ post, activeNetworkTab, setActiveNetworkTab }: NetworkTabsProps) {
  return (
    <Tabs value={activeNetworkTab} onValueChange={setActiveNetworkTab} className="w-full">
      <Tabs.List variant="menu" className="mb-4">
        {post.postSocialNetworks.map(sn => {
          const config = STATUS_STYLE_CONFIG[sn.status] || { icon: null };
          return (
            <Tabs.Trigger
              key={sn.socialNetworkId}
              value={sn.socialNetworkId}
              className="flex items-center justify-center gap-2"
            >
              <span className={`text-xs`}>{socialNetworkNames[sn.socialNetworkId]}</span>
              {config.icon}
            </Tabs.Trigger>
          );
        })}
      </Tabs.List>
    </Tabs>
  );
}
